import SectionHeading from '@/pages/home/components/SectionHeading';
import { evidenceTypes } from '@/mocks/homeData';

export default function EvidenceGrid() {
  return (
    <section id="evidence" className="scroll-mt-20 border-b border-background-200 bg-background-100/50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="02"
          eyebrow="Evidence Chain"
          title="证据链类型"
          desc="四类材料各自成链，又彼此咬合。大卡呈现资金主干，小卡补齐合同、邮件与关系网络，交叉处才是真正的关键。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-6">
          {evidenceTypes.map((item) => (
            <article
              key={item.id}
              className={`flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-foreground-300 ${item.gridClass}`}
            >
              <div className="flex items-start justify-between gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${item.icon} text-xl leading-none`}></i>
                </span>
                <span className="flex flex-col items-end">
                  <span className="font-heading text-2xl font-black leading-none text-foreground-950">
                    {item.count}
                  </span>
                  <span className="mt-1 font-label text-[11px] text-foreground-500">{item.unit}</span>
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.name}</h3>
              <p className="mt-2 text-[13px] leading-6 text-foreground-600">{item.desc}</p>

              {item.big && item.facts.length > 0 ? (
                <>
                  <dl className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
                    {item.facts.map((fact) => (
                      <div
                        key={fact.label}
                        className="rounded-md border border-background-200 bg-background-100/70 px-3 py-3"
                      >
                        <dt className="font-label text-[11px] text-foreground-500">{fact.label}</dt>
                        <dd className="mt-1 font-heading text-base font-bold text-primary-700">
                          {fact.value}
                        </dd>
                      </div>
                    ))}
                  </dl>

                  <div className="mt-6 rounded-md border border-accent-200 bg-accent-50/70 px-4 py-3.5">
                    <div className="flex items-center gap-2">
                      <i className="ri-alarm-warning-line text-base leading-none text-accent-600"></i>
                      <span className="font-label text-xs font-medium text-accent-700">
                        资金路径异常提示
                      </span>
                    </div>
                    <p className="mt-2 text-[13px] leading-6 text-accent-900">
                      检测到 28 组拆分转账，单笔金额均低于提示阈值，合计后与合同付款节点高度吻合。
                    </p>
                  </div>

                  <div className="mt-auto pt-6">
                    <span className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 font-label text-xs text-foreground-800 transition-colors hover:bg-background-100">
                      查看资金路径
                      <i className="ri-arrow-right-line text-sm leading-none"></i>
                    </span>
                  </div>
                </>
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}